import {Component, Input} from '@angular/core';
import {DASHBOARD_ROUTE} from '@core/constants/navigation/navigation.const';
import {TokenService} from '@core/modules/authentication/services';

@Component({
  selector: 'app-logo',
  template: `
    <div class="app-logo">
      <img
        src="/assets/img/logo/logo.svg"
        class="img-fluid"
        alt="Logo Pack Food Audit"
        [style.max-width]="width"
      />
      <a *ngIf="isAnchorForce || isAnchor" [routerLink]="DashboardRoute">Strona główna</a>
    </div>
  `,
  styles: [`
    .app-logo {
      position: relative;
    }
    .app-logo a {
      position: absolute;
      top: 0; right: 0; bottom: 0; left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
    }
  `]
})
export class LogoComponent {
  public readonly DashboardRoute = DASHBOARD_ROUTE;
  @Input() width: string;
  @Input() isAnchorForce: boolean = false;

  constructor(private token: TokenService) {}

  get isAnchor(): boolean {
    return this.token.isToken;
  }
}
